import React from 'react';
import ModalConfirm from './ModalConfirm';

export const ModalConfirmActivateCase = (props) => {
  const message = 'Are you sure you want to activate this case?';

  return (
    <ModalConfirm
      message={message}
      onConfirm={props.props.onConfirm}
      onClose={props.onClose}
    />
  );
};
